/// <reference types="./maintenance.d.mts" />
import * as $durations from "../../../app_config/app_config/durations.mjs";
import * as $maintenance from "../../../common/data/maintenance.mjs";
import * as $colors from "../../../ds/ds/colors.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $icons from "../../../ds/ds/icons.mjs";
import * as $logo from "../../../ds/ds/logo.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $h from "../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $s from "../../frontend/view/styles/login.mjs";
import { toList } from "../../gleam.mjs";

export function view(maintenance) {
  let duration = $durations.to_h_or_m(maintenance.ending);
  return $s.wrapper(
    toList([]),
    toList([
      $s.background(toList([$a.src("/assets/background.png")])),
      $s.topbar(
        toList([]),
        toList([
          $s.topbar_logo(toList([]), toList([$logo.light()])),
          $s.topbar_name(toList([]), toList([$h.text("Steerlab")])),
        ]),
      ),
      $s.unaligned_body(
        toList([]),
        toList([
          $s.body_pill(
            toList([]),
            toList([$icons.medium($icons.tools()), $h.text("Under maintenance")]),
          ),
          $s.body_title(
            toList([]),
            toList([$h.text("Currently steering through some fixes")]),
          ),
          $l.column(
            toList([]),
            toList([]),
            toList([
              $s.body_subtitle(
                toList([]),
                toList([$h.text("Steerlab is undergoing a maintenance.")]),
              ),
              $s.body_subtitle(
                toList([]),
                toList([
                  $h.text("Please come back in "),
                  $h.span(
                    $css.class$(toList([$css.color($colors.light.text_body)])),
                    toList([]),
                    toList([$h.text(duration + ".")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}
